module.exports = __webpack_public_path__ + "static/img/far2_active.b77eb380.png";